module.exports = __webpack_public_path__ + "img/youle.20e47486.png";